import React, { FC } from 'react';
import { Dropdown, DropdownItem } from 'fronton-react';
import { Link } from '@okapi/router-react';
import { addSlashToEndOfUrl } from 'utils/url';
import { DATA_QA_VARIANT_ITEM } from 'common/components/product-variants/variant-item';
import { ViewsModels } from 'features/variants';
import { sortAxis } from 'features/product-info/components/pdp-variants/utils';
import { AxisPoint } from 'features/product-info/components/pdp-variants/types';
import { analyticsUtils, patchUrlByLocale } from 'utils';
import { selectLink } from './styles';
import { isMatchingUrl } from './utils';

export const DATA_QA_VARIANT_SELECT = 'pdp-variant-select';

type Props = {
  variantsModel: ViewsModels.VariantsAxisModel[];
  onVariantClick: (ap: AxisPoint) => void;
  activePoint?: ViewsModels.Product;
  isProductSet: boolean;
};

export const SingleAxisDropdown: FC<Props> = ({
  variantsModel,
  onVariantClick,
  activePoint,
  isProductSet,
}) => {
  const { pointsOnAxis } = variantsModel[0];
  const sortedAxis = sortAxis(pointsOnAxis);
  const elementName = variantsModel[0]?.axisMeta?.name || '';

  const sendDropdownGA = () => {
    const elementText = activePoint?.displayedName || '';
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: isProductSet ? 'komplektyDetail / variants' : 'productDetail / variants',
      elementName,
      elementText,
    });
  };

  const onPointSelected = (val: string | null) => {
    const ap = sortedAxis.find(({ toProductUrl }) => isMatchingUrl(toProductUrl, val)) || ({} as AxisPoint);
    onVariantClick(ap);
  };
  return (
    <div data-qa={DATA_QA_VARIANT_SELECT} onClick={sendDropdownGA}>
      <Dropdown value={activePoint?.axesValues?.[0].axis || ''} label={elementName} closeOnSelect>
        {sortedAxis.map((axisPoint) => {
          const isPuncturedPoint = !!axisPoint.isPuncturedPoint;
          const productUrl = addSlashToEndOfUrl(axisPoint.toProductUrl);
          const url = patchUrlByLocale(productUrl);
          return (
            <Link key={axisPoint.label} className={selectLink} to={url} data-qa={DATA_QA_VARIANT_ITEM}>
              <DropdownItem
                value={axisPoint.label}
                text={axisPoint.label}
                disabled={isPuncturedPoint}
                onSelect={() => onPointSelected(url)}
              />
            </Link>
          );
        })}
      </Dropdown>
    </div>
  );
};
